import shopifyEnterpriseGenericDefaults from '../shopify-enterprise-generic/config.js';

export default {
  includes: ['shopify-enterprise-generic'],
  ...shopifyEnterpriseGenericDefaults,
  SearchRequestDefaults: {
    ...shopifyEnterpriseGenericDefaults.SearchRequestDefaults,
  },
  Widgets: [...shopifyEnterpriseGenericDefaults.Widgets],
};
